document.addEventListener("DOMContentLoaded", () => {
  console.log("Hello World!");
   var swiper = new Swiper(".section-brand-slider .mybrand-slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        speed:11000,
        autoplay: {
          delay: 0,
          // pauseOnMouseEnter:true,
          disableOnInteraction:false,
        },
         breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        } 
      });
});